import React, { useState, useEffect, useMemo } from "react";

import ArrowIcon from "../svg-components/ArrowIcon";

const ButtonToTop = ({ showToTopOnDesktop }) => {
  const [isVisible, setVisible] = useState(false);

  const buttonClasses = useMemo(() => {
    return showToTopOnDesktop ? "is-visible btn-scroll-top btn-scroll-top-show" : "is-visible btn-scroll-top" ;
  });

  const handleScroll = () => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  };

  const revealOnScroll = () => {
    if(document.querySelector('.btn-scroll-top') && document.body.scrollHeight / window.innerHeight >= 3 ) {
      setVisible(true);
      if(window.pageYOffset < window.innerHeight) {
        setVisible(false);
      }
    };
  };

  useEffect(() => {
    window.addEventListener('scroll', revealOnScroll);
  }, []);

  return(
    <button
      onClick={ handleScroll }
      className={ isVisible ? buttonClasses : 'btn-scroll-top' }>
      <ArrowIcon className="btn-scroll-top-arrow" title="Button to the top"/>
    </button>
  )

}

export default ButtonToTop;